import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    loading: false,
    is_submit_disable: false,
    quiz_id: null,
    page_details: {},
    language_tab: 0,
    image_file: null
  },
  mutations: {
    RESET_GENERAL_PAGES_DIALOG(state) {
      state.visibility = false
      state.page_details = {}
    },
    SET_GENERAL_PAGES_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_GENERAL_PAGES_DIALOG_QUIZ_ID(state, payload) {
      state.quiz_id = payload
    },
    SET_GENERAL_PAGES_DIALOG_PAGE_DETAILS(state, payload) {
      state.page_details = payload
    },
    SET_GENERAL_PAGES_DIALOG_UPLOADED_FILE(state, payload) {
      state.page_details.contents[payload.language].image_url = payload.url
    },
    SET_GENERAL_PAGES_DIALOG_LANGUAGE_TAB(state, payload) {
      state.language_tab = payload
    },
    SET_GENERAL_PAGES_DIALOG_LOADING(state, payload) {
      state.loading = payload
    },
    SET_GENERAL_PAGES_DIALOG_IS_SUBMIT_DISABLE(state, payload) {
      state.is_submit_disable = payload
    },
    SET_GENERAL_PAGES_DIALOG_IMAGE_FILE(state, payload) {
      state.image_file = payload
    }
  },
  actions: {
    async initGeneralPagesDialog({ commit }, payload) {
      try {
        commit('SET_GENERAL_PAGES_DIALOG_VISIBILITY', true)
        commit('SET_GENERAL_PAGES_DIALOG_LOADING', true)
        const response = await api.getGeneralPage(payload)
        if (response.data.success) {
          commit('SET_GENERAL_PAGES_DIALOG_QUIZ_ID', payload.quiz_id)
          commit('SET_GENERAL_PAGES_DIALOG_PAGE_DETAILS', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_GENERAL_PAGES_DIALOG_LOADING', false)
      }
    },
    async updateGeneralPage({ rootState, state, commit, dispatch }) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', Vuetify.locale.t(`$vuetify.__EventManager.quiz_library.${state.page_details.page_type}`)),
          loading: true
        })
        const device_id = rootState.auth.selected_device

        let params = { quiz_id: state.quiz_id, page_type: state.page_details.page_type, params: { device_id: device_id, is_on: state.page_details.is_on, contents: state.page_details.contents } }
        const response = await api.updateGeneralPage(params)
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.update', Vuetify.locale.t(`$vuetify.__EventManager.quiz_library.${state.page_details.page_type}`)),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_GENERAL_PAGES_DIALOG')
          dispatch('fetchQuizDetail', state.quiz_id)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async uploadGeneralPagesFiles({ rootState, state, commit }, payload) {
      try {
        commit('SET_GENERAL_PAGES_DIALOG_IS_SUBMIT_DISABLE', true)
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.uploading', Vuetify.locale.t('$vuetify.__General.image')),
          loading: true
        })

        const device_id = rootState.auth.selected_device
        const form_data = new FormData()
        form_data.append('images', state.image_file)
        form_data.append('device_id', device_id)

        const response = await api.uploadEventMediaFile({ params: form_data, headers: { 'Content-Type': 'multipart/form-data' } })
        if (response.data.success) {
          commit('SET_GENERAL_PAGES_DIALOG_UPLOADED_FILE', { url: response.data.data.urls[0], language: payload })
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.upload', Vuetify.locale.t('$vuetify.__General.images')),
            icon: 'check',
            timeout: '2000'
          })
        } else throw Error(response.data.message)
      } catch (error) {
        console.log(error)
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_GENERAL_PAGES_DIALOG_IS_SUBMIT_DISABLE', false)
      }
    }
  }
}
